module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-wood-rovere-termocotto.68414aa5.jpg";